varying vec2 vUV;

void main() {
    vec4 worldPosition = modelMatrix * vec4( position, 1.0);
  	gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    vUV = uv * 0.25;
}